import { render } from "./tipo.vue?vue&type=template&id=e9106a3e&scoped=true"
import script from "./tipo.vue?vue&type=script&lang=js"
export * from "./tipo.vue?vue&type=script&lang=js"

import "./tipo.vue?vue&type=style&index=0&id=e9106a3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9106a3e"]])

export default __exports__